/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgSearch = (props: React.SVGProps<SVGSVGElement>) => (
  <svg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' {...props}>
    <path
      d='M1.3603 7.2272c0-3.2403 2.627-5.8672 5.8673-5.8672 3.2404 0 5.8673 2.6269 5.8673 5.8672 0 1.2447-.3876 2.399-1.0487 3.3485l2.2887 2.2887c.4062.4061.4062 1.0646 0 1.4708-.4061.4061-1.0646.4061-1.4708 0l-2.2888-2.2889c-.9494.6608-2.1033 1.0482-3.3477 1.0482-3.2404 0-5.8672-2.6269-5.8672-5.8673ZM7.2277 3.44c-2.0916 0-3.7872 1.6956-3.7872 3.7872 0 2.0917 1.6956 3.7873 3.7872 3.7873 2.0917 0 3.7873-1.6956 3.7873-3.7873 0-2.0916-1.6957-3.7872-3.7873-3.7872Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgSearch
